import React, { useEffect, useState } from 'react';
import { TextInput } from 'react-native';
import { Button, Modal } from '@app/components';
import { modalsSelectors } from '@app/store';
import { useAppSelector } from '@app/store/hooks';
import { normalize } from '@app/helpers';

interface Props {
  id: string;
  serviceId: string;
  close: () => void;
  onConfirm: (reason: string) => void;
  isLoading?: boolean;
}

// Retirer le mode école d'une commande la rend vendable pour de vrai sur
// toutes les caisses : la raison est obligatoire, elle part dans l'historique.
export const ReleaseEcoleModal = ({ id, serviceId, close, onConfirm, isLoading }: Props) => {
  const modal = useAppSelector((state) => modalsSelectors.selectById(state, id));
  const [reason, setReason] = useState('');
  const valide = reason.trim().length >= 3;

  // La modale n'est pas démontée à la fermeture : sans cette remise à zéro, la
  // raison du relâchement précédent réapparaît à la réouverture, prête à être
  // confirmée par mégarde sur une autre commande.
  useEffect(() => {
    if (!modal?.isOpen) setReason('');
  }, [modal?.isOpen]);

  return (
    <Modal isOpen={!!modal?.isOpen}>
      <Modal.Title>Retirer le mode école</Modal.Title>
      <Modal.Subtitle>Commande #{serviceId}</Modal.Subtitle>
      <Modal.Message>
        Cette commande a été encaissée en mode école. En retirant ce mode, elle redevient une commande ordinaire, vendable pour de vrai, sur toutes les caisses du restaurant. Indiquez la raison : elle sera conservée dans l’historique de la commande, et enregistrée au journal fiscal de la caisse qui a émis le ticket école.
      </Modal.Message>
      <TextInput
        value={reason}
        onChangeText={setReason}
        placeholder="Raison (3 à 200 caractères)"
        maxLength={200}
        style={{ backgroundColor: '#FDFFFC', borderRadius: normalize(6), padding: normalize(10), width: 480, marginBottom: normalize(12) }}
        testID="raison-ecole" />
      <Modal.Action>
        <Button title="Annuler" onPress={close} large />
        <Button title="Retirer le mode école" onPress={() => onConfirm(reason.trim())} large bordered loading={isLoading} disabled={!valide} />
      </Modal.Action>
    </Modal>
  );
};
